import React from "react";

const AuthContext = React.createContext({
  currentUser: { isLoggedIn: false },
  onLoggedIn: () => console.log("auth context onLoggedIn() default"),
  onLoggedOut: () => console.log("auth context onLoggedOut() default"),
  onSignup: () => console.log("auth context onSignup() default"),
});

export default AuthContext;
